<template>
    <main class="w-full py-8 px-6 mx-auto" style="min-height: calc(100vh - 12rem)">
        <DashboardContentHeader
            :heading="heading"
            :subheading="subheading"
            :has-period-picker="hasPeriodPicker"
            :has-pig-type-picker="hasPigTypePicker"
            :slim-pig-type-picker="slimPigTypePicker"
        >
            <template v-if="$slots['above-heading']" #above-heading><slot name="above-heading"></slot></template>
            <template v-if="$slots.subheading" #subheading><slot name="subheading"></slot></template>
            <template #top-right><slot name="header-top-right"></slot></template>
        </DashboardContentHeader>
        <slot></slot>
    </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentHeader from '@/components/layouts/dashboardLayout/content/DashboardContentHeader.vue';

export default defineComponent({
    components: { DashboardContentHeader },
    props: {
        heading: {
            type: String,
            default: '',
        },
        subheading: {
            type: String,
            default: '',
        },
        hasPigTypePicker: {
            type: Boolean,
            default: false,
        },
        hasPeriodPicker: {
            type: Boolean,
            default: false,
        },
        slimPigTypePicker: {
            type: Boolean,
            default: false,
        },
    },
});
</script>
